import { module } from 'angular';

import { Form, Popup } from './';
import { default as transferServiceName, TransferDeprecatedService } from './transfer-deprecated.service';

export default module('contact.agent.core.contact.transfer', [Form, Popup])
  .service(transferServiceName, TransferDeprecatedService)
  .run([transferServiceName, () => {}]).name;
